(function () {
	'use strict';

	// ---------- Константы ----------
	var LS_EVENTS		= 'bloom_session_events';
	var LS_CART			= 'bloom_session_cart';
	var LS_PANEL_SIZE	= 'bloom_session_panel_size';
	var COOKIE_COLLAPSED	= 'bloom_session_panel_collapsed';
	var COOKIE_FLUSH		= 'bloom_session_flush_to_server';

	var PANEL_ID		= 'bloom-session-panel';
	var STYLE_ID		= 'bloom-session-style';

	// Ограничения resize (в пикселях). Реальные верхние границы
	// дополнительно режутся размером вьюпорта, см. clampSize().
	var PANEL_MIN_W		= 240;
	var PANEL_MIN_H		= 160;
	var PANEL_DEFAULT_W	= 340;
	var PANEL_VIEWPORT_PAD	= 32;

	// Цвета категорий событий для debug-панели
	var EVENT_COLORS = {
		brand_view:			'#d97706',
		collection_view:	'#2563eb',
		product_view:		'#059669',
		search:				'#7c3aed',
		search_click:		'#9333ea',
		yml_click:			'#db2777',
		similar_click:		'#e11d48',
		recent_click:		'#0891b2',
		ask_ai:				'#f59e0b',
		add_to_cart:		'#16a34a'
	};

	// Зарезервированные dataset-ключи, которые игнорируем при сборе payload.
	// `properties` использует open_preview_layer (snippets/product-preview-layer.liquid)
	// для прокидывания line item properties (_call_source, _ai_data) в Shopify cart —
	// к нашему трекингу это не относится.
	// `customerOrdersCount`, `customerTotalSpent`, `customerTags`, `customerCreatedAt` —
	// профиль customer'а живёт на <body> чтобы bootstrap смог положить его в session_start
	// и identify events. В каждое product_view/pageview их тащить смысла нет — раздувает
	// payload и сохраняет stale snapshot.
	var RESERVED_DATA_KEYS = [
		'properties',
		// Customer-stats умышленно не дублируем в каждый event payload —
		// для join'а достаточно customer_id (всё остальное берётся из bs_visitors/bloom_customers).
		'customerOrdersCount',
		'customerTotalSpent',
		'customerTags',
		'customerCreatedAt',
		// Browser-extension noise (Grammarly, SmartConverter и т.п.) — эти расширения
		// инжектят свои data-* атрибуты на body/article при загрузке страницы.
		// Не наш код, но dataset их видит. Отфильтровываем чтобы не засорять payload.
		'grExtInstalled',
		'newGrCSCheckLoaded',
		'newGrCSLoaded',
		'smartConverterLoaded',
		'scrollDirection',
		'mceFragment',
		'pinDo',
		'fragUrl',
		'mountedAt'
	];

	// ---------- Утилиты ----------
	function setCookie(name, value, days) {
		try {
			var exp = '';
			if (typeof days === 'number') {
				var d = new Date();
				d.setTime(d.getTime() + days * 864e5);
				exp = '; expires=' + d.toUTCString();
			}
			document.cookie = name + '=' + encodeURIComponent(value) + exp + '; path=/; SameSite=Lax';
		} catch (e) {}
	}

	function getCookie(name) {
		try {
			var prefix = name + '=';
			var parts = document.cookie ? document.cookie.split(';') : [];
			for (var i = 0; i < parts.length; i++) {
				var c = parts[i].replace(/^\s+/, '');
				if (c.indexOf(prefix) === 0) {
					return decodeURIComponent(c.substring(prefix.length));
				}
			}
		} catch (e) {}
		return null;
	}

	function safeParse(json, fallback) {
		try {
			var v = JSON.parse(json);
			return v == null ? fallback : v;
		} catch (e) {
			return fallback;
		}
	}

	function readEvents() {
		return safeParse(localStorage.getItem(LS_EVENTS), []) || [];
	}

	function writeEvents(list) {
		try {
			localStorage.setItem(LS_EVENTS, JSON.stringify(list));
		} catch (e) {}
	}

	function clearEvents() {
		try {
			localStorage.removeItem(LS_EVENTS);
		} catch (e) {}
	}

	function readStoredCart() {
		try {
			return localStorage.getItem(LS_CART);
		} catch (e) {
			return null;
		}
	}

	function writeStoredCart(token) {
		try {
			if (token) localStorage.setItem(LS_CART, token);
		} catch (e) {}
	}

	function formatTime(ts) {
		var d = new Date(ts);
		var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
		return pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
	}

	function bytesSize(str) {
		if (!str) return 0;
		try { return new Blob([str]).size; }
		catch (e) { return str.length; }
	}

	function formatSize(bytes) {
		if (bytes < 1024) return bytes + 'b';
		return (bytes / 1024).toFixed(1) + 'kb';
	}

	function escapeHtml(s) {
		if (s == null) return '';
		return String(s)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function shortToken(t) {
		if (!t) return '—';
		if (t.length <= 12) return t;
		return t.substring(0, 8) + '...';
	}

	// ---------- Ядро: добавление события ----------
	function _bsUuid() {
		if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	// Dedup идентичных событий в коротком окне. Защита от двойного срабатывания
	// делегированного click-листенера (напр. если bloom-session.js исполнился дважды
	// и initListeners навесил document.click повторно) — иначе один тык по prompt-кнопке
	// ask-ai-box писался 3-5 раз. Реальный баг: 15-22 мая 2026 (ask_ai via=product_page
	// раздувался 2.8-4.4x). Окно 800мс: human-повторы редки, programmatic-дубли в ту же
	// секунду — гарантированно схлопываются.
	var _bsRecentEvents = {};
	function _bsIsDuplicate(evt) {
		// Для search один и тот же запрос приходит с via=null и via='search'
		// (form-submit/emitSearchEvent vs view-derived) — via в ключе мешал бы
		// схлопыванию, поэтому для type='search' via из ключа исключаем.
		var viaKey = evt.type === 'search' ? '' : (evt.via || '');
		var key = [evt.type, evt.handle || '', viaKey, evt.mode || '',
		           evt.pattern || '', evt.query || ''].join('|');
		var now = Date.now();
		var prev = _bsRecentEvents[key];
		_bsRecentEvents[key] = now;
		return prev && (now - prev) < 800;
	}

	// Комбинаторный обход фасетов: /collections/<handle>/<tag>+<tag>+... Живой человек
	// ставит 1-3 фильтра; скрейпер берёт весь набор тегов товара и делает URL со всеми
	// сразу (август 2026: 312k уникальных адресов за 6 дней, каждый — своя «сессия»).
	// С таких страниц аналитику не собираем вообще. На работу самой страницы не влияет.
	var MIN_FACET_TAGS = 4;

	function _bsIsFacetSpam(path) {
		var m = String(path || '').match(/^\/collections\/[^/?#]+\/([^?#]+)/);
		return !!m && m[1].split('+').length >= MIN_FACET_TAGS;
	}

	function pushEvent(evt) {
		if (!evt || !evt.type) return;
		if (_bsIsFacetSpam(location.pathname)) return;
		if (_bsIsDuplicate(evt)) return;
		var list = readEvents();
		var record = { ts: Date.now() };
		for (var k in evt) {
			if (Object.prototype.hasOwnProperty.call(evt, k)) {
				record[k] = evt[k];
			}
		}
		// camelCase из body.dataset → snake_case для совместимости с серверной схемой колонок.
		// Важно: data-customer-id в dataset становится customerId, но колонка — customer_id.
		// Без этого product_view/brand_view/collection_view/search теряют customer_id.
		var renames = {
			customerId:      'customer_id',
			cartToken:       'cart_token',
			orderId:         'order_id',
			priceGbp:        'price_gbp',
			samplesStatus:   'samples_status',
			bottlesStatus:   'bottles_status',
			cartItems:       'cart_items',
			cartTotal:       'cart_total',
			abVariant:       'ab_variant'    // announcements баннеры: data-ab-variant="v1|v2"
		};
		for (var camel in renames) {
			if (Object.prototype.hasOwnProperty.call(record, camel) && !record[renames[camel]]) {
				record[renames[camel]] = record[camel];
				delete record[camel];
			}
		}

		// проставляем event_id и пометку _unsent чтобы transport-флашер забрал событие
		if (!record.event_id) record.event_id = _bsUuid();
		if (!record.host && document.body && document.body.dataset && document.body.dataset.host) {
			record.host = document.body.dataset.host;
		}
		// customer_id — на любом event'е если юзер залогинен. Без этого MCP-аналитика
		// не видит залогиненную активность кроме явных identify events.
		if (!record.customer_id && document.body && document.body.dataset && document.body.dataset.customerId) {
			record.customer_id = document.body.dataset.customerId;
		}
		// cart_token нужен серверу для связки browser-сессии с purchase webhook'ом
		// (через JOIN bs_sessions.cart_token = bs_events[type=purchase].cart_token).
		// Без этого funnel.purchase_sessions = 0 даже при реальных покупках.
		if (!record.cart_token && window.__bloomCartToken) {
			record.cart_token = window.__bloomCartToken;
		}
		record._unsent = true;

		list.push(record);
		writeEvents(list);
		renderPanel();

		// После add_to_cart Shopify мог создать/сменить cart cookie —
		// догоняем токен, чтобы панель показывала актуальное значение.
		// Небольшая задержка: к моменту pushEvent ответ /cart/add.js
		// ещё мог не успеть обновить cookie на стороне браузера.
		if (record.type === 'add_to_cart') {
			setTimeout(refreshCartToken, 300);
		}
	}

	function pushEventFromDataset(ds, excludeKeys) {
		if (!ds) return;
		var type = ds.event;
		if (!type) return;
		var payload = { type: type };
		for (var k in ds) {
			if (!Object.prototype.hasOwnProperty.call(ds, k)) continue;
			if (k === 'event') continue;
			if (RESERVED_DATA_KEYS.indexOf(k) !== -1) continue;
			if (excludeKeys && excludeKeys.indexOf(k) !== -1) continue;
			payload[k] = ds[k];
		}
		pushEvent(payload);
	}

	// ---------- Cart token ----------
	//
	// Источники токена (в порядке приоритета):
	//
	//   1. Shopify.Checkout.cartToken    — синхронно, есть на всех
	//                                      страницах темы.        Формат: голый токен.
	//   2. cookie `cart`                 — синхронно, ставится Shopify.   Формат: голый токен.
	//   3. window.cartToken              — null из
	//                                      layout/theme.liquid. На CDN-кэшированных
	//                                      страницах часто null.            Формат: голый токен.
	//   4. fetch /cart.js                — асинхронный fallback.          Формат: <token>?key=<hmac>.
	//
	// Источники 1–3 отдают «голый» токен, /cart.js — с `?key=…` для защиты
	// последующих cart-операций. Для сравнения сессий и отображения нам нужен
	// сам base-token, поэтому нормализуем — обрезаем всё после `?`.
	function normalizeToken(t) {
		if (!t) return null;
		var s = String(t);
		var q = s.indexOf('?');
		return q === -1 ? s : s.substring(0, q);
	}

	function readCartTokenSync() {
		try {
			if (window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.cartToken) {
				return String(window.Shopify.Checkout.cartToken);
			}
		} catch (e) {}
		var ck = getCookie('cart');
		if (ck) return ck;
		if (typeof window.cartToken === 'string' && window.cartToken) {
			return window.cartToken;
		}
		return null;
	}

	function getCartToken() {
		var sync = readCartTokenSync();
		if (sync) return Promise.resolve(normalizeToken(sync));
		if (typeof fetch !== 'function') return Promise.resolve(null);
		return fetch('/cart.js', { credentials: 'same-origin' })
			.then(function (r) { return r.ok ? r.json() : null; })
			.then(function (j) { return (j && j.token) ? normalizeToken(j.token) : null; })
			.catch(function () { return null; });
	}

	function initCartSync() {
		return getCartToken().then(function (current) {
			var stored = readStoredCart();

			// НЕ чистим events queue при смене cart_token — это race с bootstrap.js,
			// который параллельно эмитит session_start/pageview/identify в тот же localStorage.
			// Идемпотентность ingest'а на сервере (INSERT IGNORE по event_id) делает client-side
			// wipe ненужным; transport.js сам подрезает уже-отправленные события.

			if (current) writeStoredCart(current);

			window.__bloomCartToken = current;
			return current;
		});
	}

	// Перезапрашиваем токен и обновляем панель.
	// Используется после add_to_cart, когда Shopify мог
	// только что создать/сменить cart cookie.
	function refreshCartToken() {
		return initCartSync().then(function (token) {
			renderPanel();
			return token;
		});
	}

	// ---------- Pageload-событие ----------
	function firePageloadEvent() {
		var body = document.body;
		if (!body) return;
		var pe = body.dataset.pageEvent;
		if (!pe) return;

		pushEventFromDatasetBody(body.dataset);
	}

	// body.dataset.pageEvent → type; все остальные data-* → поля
	function pushEventFromDatasetBody(ds) {
		var type = ds.pageEvent;
		if (!type) return;
		var payload = { type: type };
		for (var k in ds) {
			if (!Object.prototype.hasOwnProperty.call(ds, k)) continue;
			if (k === 'pageEvent') continue;
			if (RESERVED_DATA_KEYS.indexOf(k) !== -1) continue;
			payload[k] = ds[k];
		}
		// Прокидываем document.referrer всегда — для post-hoc атрибуции
		if (!payload.referrer && document.referrer) payload.referrer = document.referrer;

		// Источник #1: sessionStorage-флаг от bootstrap (AJAX search-dropdown click)
		// или баннеров на главной. Юзер кликнул элемент на предыдущей странице,
		// клиент записал флаг с handle/via, мы его подхватываем тут на destination.
		// Применяется к любому view-событию (product/collection/brand): handle совпадает
		// либо `*` — любой destination (баннер на /pages/X где handle=page-handle).
		var emitSearchEvent = false;
		if ((type === 'product_view' || type === 'collection_view' || type === 'brand_view' || type === 'article_view') && (payload.handle || payload.collection || payload.brand)) {
			try {
				var raw = sessionStorage.getItem('bs_next_via');
				if (raw) {
					var flag = JSON.parse(raw);
					var dest = payload.handle || payload.collection || payload.brand;
					if (flag && flag.expires_at > Date.now() && (flag.handle === dest || flag.handle === '*')) {
						payload.via = flag.via;
						if (flag.query) payload.query = flag.query;
					}
					sessionStorage.removeItem('bs_next_via');
				}
			} catch (_) {}
		}

		// Источник #2: referrer (нативная /search?q=, /collections, /brands страница).
		if (!payload.via && document.referrer) {
			try {
				var refUrl = new URL(document.referrer);
				if (refUrl.hostname.indexOf('bloomperfume') !== -1) {
					var refPath = refUrl.pathname || '';
					if (refUrl.searchParams && refUrl.searchParams.get('q') && /\/search/.test(refPath)) {
						payload.via = 'search';
						payload.query = refUrl.searchParams.get('q');
						emitSearchEvent = true;
					} else if (/\/search/.test(refPath)) {
						payload.via = 'search';
					} else if (/\/collections\//.test(refPath)) {
						payload.via = 'collection';
					} else if (/\/brands?\//.test(refPath)) {
						payload.via = 'brand';
					}
				}
			} catch (e) {}
		}

		pushEvent(payload);

		// Сохраняем via текущего PDP в sessionStorage, чтобы cart-btn click handler
		// мог пробросить его в add_to_cart event (без trick'а через session-level lookup).
		// Кладём только для product_view с handle и via — другие view-типы не нужны.
		if (type === 'product_view' && payload.handle && payload.via) {
			try {
				sessionStorage.setItem('bs_pdp_via', JSON.stringify({
					handle: payload.handle,
					via:    payload.via,
					ts:     Date.now()
				}));
			} catch (_) {}
		}

		// Native /search → product клик: помимо product_view эмитим search event
		// как сигнал успешного поиска. (Для AJAX-варианта search event эмитит сам bootstrap.)
		if (emitSearchEvent && type === 'product_view' && payload.query) {
			pushEvent({ type: 'search', query: payload.query, url: payload.url || null });
		}
	}

	// ---------- Делегированные listener'ы ----------
	function initListeners() {
		document.addEventListener('click', function (e) {
			var el = e.target && e.target.closest ? e.target.closest('.bsx') : null;
			if (!el) return;
			// Для форм клик не триггерит событие — только submit
			if (el.tagName === 'FORM') return;
			if (!el.dataset.event) return;
			pushEventFromDataset(el.dataset);
		}, true);

		// Любая ссылка с data-via → ставим bs_next_via флаг чтобы destination'ое
		// view-событие подхватило via. Так в debug-панели на странице назначения
		// сразу видно "via: index_new_in" / "via: collection" и т.д.
		// Capture-phase (true) — чтобы успеть до browser-навигации.
		document.addEventListener('click', function (e) {
			var a = e.target && e.target.closest ? e.target.closest('a[data-via]') : null;
			if (!a) return;
			var via = a.getAttribute('data-via');
			if (!via) return;
			var href = a.getAttribute('href') || '';
			var m = href.match(/\/(?:products|collections|pages|blogs\/[^/]+)\/([^/?#]+)/);
			var dest = (m ? m[1] : a.getAttribute('data-handle') || '') || '*';
			try {
				sessionStorage.setItem('bs_next_via', JSON.stringify({
					handle:     dest,
					via:        via,
					expires_at: Date.now() + 60 * 1000
				}));
			} catch (_) {}
		}, true);

		document.addEventListener('submit', function (e) {
			var form = e.target && e.target.closest ? e.target.closest('.bsx') : null;
			if (!form) return;
			var type = form.dataset.event;
			if (type !== 'search') return;
			var qInput = form.querySelector('input[name="q"]');
			var query = qInput && qInput.value ? qInput.value.trim() : '';
			if (!query) return;
			pushEvent({ type: 'search', query: query });
		}, true);

		window.addEventListener('storage', function (e) {
			if (e.key === LS_EVENTS || e.key === LS_CART) {
				renderPanel();
			}
		});
	}

	// ---------- Debug-панель ----------
	var panelState = {
		collapsed:	false
	};

	// ---------- Resize: загрузка/сохранение/применение ----------
	function loadSize() {
		var raw = null;
		try { raw = localStorage.getItem(LS_PANEL_SIZE); } catch (e) {}
		var v = safeParse(raw, null);
		if (!v || typeof v !== 'object') return null;
		var w = Number(v.w);
		var h = Number(v.h);
		if (!isFinite(w) || !isFinite(h)) return null;
		return { w: w, h: h };
	}

	function saveSize(w, h) {
		try {
			localStorage.setItem(LS_PANEL_SIZE, JSON.stringify({ w: w, h: h }));
		} catch (e) {}
	}

	function clampSize(w, h) {
		var maxW = Math.max(PANEL_MIN_W, window.innerWidth  - PANEL_VIEWPORT_PAD);
		var maxH = Math.max(PANEL_MIN_H, window.innerHeight - PANEL_VIEWPORT_PAD);
		if (w < PANEL_MIN_W) w = PANEL_MIN_W;
		if (h < PANEL_MIN_H) h = PANEL_MIN_H;
		if (w > maxW) w = maxW;
		if (h > maxH) h = maxH;
		return { w: w, h: h };
	}

	function applySavedSize(panel) {
		var saved = loadSize();
		var w = saved && saved.w ? saved.w : PANEL_DEFAULT_W;
		var h = saved && saved.h ? saved.h : Math.round(window.innerHeight * 0.7);
		var c = clampSize(w, h);
		panel.style.width  = c.w + 'px';
		panel.style.height = c.h + 'px';
	}

	function initResize(panel) {
		var handle = panel.querySelector('.bs-resize-handle');
		if (!handle) return;

		var startX = 0, startY = 0, startW = 0, startH = 0;
		var dragging = false;

		function onMove(e) {
			if (!dragging) return;
			var dx = e.clientX - startX;
			// Панель anchored к bottom-left, ручка — в верхнем-правом углу.
			// Тянем вверх (dy < 0) → высота должна расти.
			var dy = startY - e.clientY;
			var c = clampSize(startW + dx, startH + dy);
			panel.style.width  = c.w + 'px';
			panel.style.height = c.h + 'px';
			e.preventDefault();
		}

		function onUp() {
			if (!dragging) return;
			dragging = false;
			panel.classList.remove('bs-resizing');
			document.removeEventListener('mousemove', onMove, true);
			document.removeEventListener('mouseup',   onUp,   true);
			saveSize(panel.offsetWidth, panel.offsetHeight);
		}

		handle.addEventListener('mousedown', function (e) {
			if (panelState.collapsed) return;
			if (e.button !== 0) return;
			dragging = true;
			startX = e.clientX;
			startY = e.clientY;
			startW = panel.offsetWidth;
			startH = panel.offsetHeight;
			panel.classList.add('bs-resizing');
			document.addEventListener('mousemove', onMove, true);
			document.addEventListener('mouseup',   onUp,   true);
			e.preventDefault();
			e.stopPropagation();
		});

		// Если окно браузера сильно уменьшилось — подрезаем размеры панели,
		// чтобы она не вылезла за вьюпорт.
		window.addEventListener('resize', function () {
			if (panelState.collapsed) return;
			var c = clampSize(panel.offsetWidth, panel.offsetHeight);
			panel.style.width  = c.w + 'px';
			panel.style.height = c.h + 'px';
		});
	}

	function injectStyles() {
		if (document.getElementById(STYLE_ID)) return;
		var css = [
			'@media (max-width: 909px) {',
			'	#' + PANEL_ID + ' { display: none !important; }',
			'}',
			'#' + PANEL_ID + ' {',
			'	position: fixed;',
			'	left: 16px;',
			'	bottom: 16px;',
			'	background: #ffffff;',
			'	color: #111827;',
			'	border: 1px solid #e5e7eb;',
			'	border-radius: 10px;',
			'	box-shadow: 0 10px 30px rgba(0,0,0,0.18);',
			'	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;',
			'	font-size: 12px;',
			'	line-height: 1.4;',
			'	z-index: 99999;',
			'	display: flex;',
			'	flex-direction: column;',
			'	overflow: hidden;',
			'	box-sizing: border-box;',
			'}',
			'#' + PANEL_ID + '.bs-collapsed {',
			'	width: 44px !important;',
			'	height: 44px !important;',
			'	max-height: 44px !important;',
			'	border-radius: 50%;',
			'	cursor: pointer;',
			'	align-items: center;',
			'	justify-content: center;',
			'	text-align: center;',
			'	font-size: 22px;',
			'}',
			'#' + PANEL_ID + '.bs-collapsed .bs-resize-handle { display: none; }',
			'#' + PANEL_ID + ' .bs-resize-handle {',
			'	position: absolute;',
			'	top: 0;',
			'	right: 0;',
			'	width: 14px;',
			'	height: 14px;',
			'	cursor: nesw-resize;',
			'	z-index: 2;',
			'}',
			'#' + PANEL_ID + ' .bs-resize-handle::before {',
			'	content: "";',
			'	position: absolute;',
			'	top: 3px;',
			'	right: 3px;',
			'	width: 0;',
			'	height: 0;',
			'	border-style: solid;',
			'	border-width: 0 8px 8px 0;',
			'	border-color: transparent #d1d5db transparent transparent;',
			'}',
			'#' + PANEL_ID + ' .bs-resize-handle:hover::before {',
			'	border-color: transparent #6b7280 transparent transparent;',
			'}',
			'#' + PANEL_ID + '.bs-resizing { user-select: none; }',
			'#' + PANEL_ID + '.bs-collapsed .bs-body,',
			'#' + PANEL_ID + '.bs-collapsed .bs-toolbar,',
			'#' + PANEL_ID + '.bs-collapsed .bs-header { display: none; }',
			'#' + PANEL_ID + '.bs-collapsed .bs-collapsed-icon { display: block; }',
			'#' + PANEL_ID + ' .bs-collapsed-icon { display: none; line-height: 44px; }',
			'#' + PANEL_ID + ' .bs-header {',
			'	display: flex;',
			'	align-items: center;',
			'	padding: 8px 10px;',
			'	background: linear-gradient(135deg, #fdf2f8, #fef3c7);',
			'	border-bottom: 1px solid #e5e7eb;',
			'	gap: 8px;',
			'}',
			'#' + PANEL_ID + ' .bs-title {',
			'	font-weight: 600;',
			'	flex: 0 0 auto;',
			'}',
			'#' + PANEL_ID + ' .bs-meta {',
			'	flex: 1 1 auto;',
			'	display: flex;',
			'	flex-direction: column;',
			'	font-size: 11px;',
			'	color: #374151;',
			'	overflow: hidden;',
			'}',
			'#' + PANEL_ID + ' .bs-cart {',
			'	cursor: pointer;',
			'	white-space: nowrap;',
			'	overflow: hidden;',
			'	text-overflow: ellipsis;',
			'}',
			'#' + PANEL_ID + ' .bs-cart:hover { color: #111827; text-decoration: underline; }',
			'#' + PANEL_ID + ' .bs-counts {',
			'	color: #6b7280;',
			'	font-size: 10px;',
			'}',
			'#' + PANEL_ID + ' .bs-header-btns {',
			'	display: flex;',
			'	gap: 4px;',
			'	flex: 0 0 auto;',
			'}',
			'#' + PANEL_ID + ' .bs-btn {',
			'	background: #ffffff;',
			'	border: 1px solid #d1d5db;',
			'	border-radius: 4px;',
			'	cursor: pointer;',
			'	font-size: 12px;',
			'	line-height: 1;',
			'	padding: 4px 8px;',
			'	color: #111827;',
			'}',
			'#' + PANEL_ID + ' .bs-btn:hover { background: #f3f4f6; }',
			'#' + PANEL_ID + ' .bs-btn-icon {',
			'	width: 22px;',
			'	height: 22px;',
			'	padding: 0;',
			'	display: inline-flex;',
			'	align-items: center;',
			'	justify-content: center;',
			'}',
			'#' + PANEL_ID + ' .bs-toolbar {',
			'	display: flex;',
			'	gap: 6px;',
			'	padding: 6px 10px;',
			'	border-bottom: 1px solid #e5e7eb;',
			'	background: #f9fafb;',
			'	align-items: center;',
			'}',
			'#' + PANEL_ID + ' .bs-flush-toggle {',
			'	display: flex; gap: 4px; align-items: center;',
			'	margin-left: auto; font-size: 11px; color: #4b5563; cursor: pointer; user-select: none;',
			'}',
			'#' + PANEL_ID + ' .bs-flush-toggle input { margin: 0; cursor: pointer; }',
			'#' + PANEL_ID + ' .bs-body {',
			'	overflow-y: auto;',
			'	flex: 1 1 auto;',
			'	padding: 4px 0;',
			'}',
			'#' + PANEL_ID + ' .bs-empty {',
			'	padding: 16px;',
			'	text-align: center;',
			'	color: #9ca3af;',
			'	font-style: italic;',
			'}',
			'#' + PANEL_ID + ' .bs-event {',
			'	padding: 6px 10px;',
			'	border-bottom: 1px solid #f3f4f6;',
			'}',
			'#' + PANEL_ID + ' .bs-event:last-child { border-bottom: none; }',
			'#' + PANEL_ID + ' .bs-event-head {',
			'	display: flex;',
			'	gap: 8px;',
			'	align-items: baseline;',
			'}',
			'#' + PANEL_ID + ' .bs-event-time {',
			'	color: #6b7280;',
			'	font-family: ui-monospace, SFMono-Regular, Menlo, monospace;',
			'	font-size: 11px;',
			'}',
			'#' + PANEL_ID + ' .bs-event-type {',
			'	font-weight: 600;',
			'	font-size: 12px;',
			'}',
			'#' + PANEL_ID + ' .bs-event-fields {',
			'	margin-top: 2px;',
			'	font-family: ui-monospace, SFMono-Regular, Menlo, monospace;',
			'	font-size: 11px;',
			'	color: #374151;',
			'	padding-left: 4px;',
			'}',
			'#' + PANEL_ID + ' .bs-event-field {',
			'	white-space: nowrap;',
			'	overflow: hidden;',
			'	text-overflow: ellipsis;',
			'}',
			'#' + PANEL_ID + ' .bs-event-field-k { color: #6b7280; }',
			'#' + PANEL_ID + ' .bs-event-field-v { color: #111827; }'
		].join('\n');

		var style = document.createElement('style');
		style.id = STYLE_ID;
		style.textContent = css;
		(document.head || document.documentElement).appendChild(style);
	}

	function createPanel() {
		if (document.getElementById(PANEL_ID)) return;

		var panel = document.createElement('div');
		panel.id = PANEL_ID;

		panel.innerHTML = [
			'<div class="bs-collapsed-icon">🌸</div>',
			'<div class="bs-resize-handle" title="Drag to resize"></div>',
			'<div class="bs-header">',
			'	<div class="bs-title">🌸</div>',
			'	<div class="bs-meta">',
			'		<span class="bs-cart" title="Click to copy cart_token">cart: —</span>',
			'		<span class="bs-counts">events: 0    size: 0b</span>',
			'	</div>',
			'	<div class="bs-header-btns">',
			'		<button class="bs-btn bs-btn-icon" data-act="collapse" title="Collapse">_</button>',
			'	</div>',
			'</div>',
			'<div class="bs-toolbar">',
			'	<button class="bs-btn" data-act="clear">Clear</button>',
			'	<button class="bs-btn" data-act="copy">Copy JSON</button>',
			'	<label class="bs-flush-toggle" title="Send events to /session backend (default: off — events stay local)">',
			'		<input type="checkbox" data-act="flush-toggle"> flush to server',
			'	</label>',
			'</div>',
			'<div class="bs-body"></div>'
		].join('\n');

		document.body.appendChild(panel);
		applySavedSize(panel);
		initResize(panel);

		panel.addEventListener('click', function (e) {
			var tgt = e.target;
			if (!tgt) return;

			if (panelState.collapsed) {
				panelState.collapsed = false;
				setCookie(COOKIE_COLLAPSED, '0', 365);
				applyPanelState();
				e.stopPropagation();
				return;
			}

			// Чекбокс — пропускаем дальше, его обрабатывает change-listener ниже,
			// иначе stopPropagation помешает change-событию.
			if (tgt.matches && tgt.matches('input[type="checkbox"][data-act]')) return;

			var actEl = tgt.closest ? tgt.closest('[data-act]') : null;
			if (actEl) {
				var act = actEl.dataset.act;
				handlePanelAction(act);
				e.stopPropagation();
				return;
			}

			if (tgt.closest && tgt.closest('.bs-cart')) {
				copyToClipboard(window.__bloomCartToken || '');
				return;
			}
		});

		panel.addEventListener('change', function (e) {
			var tgt = e.target;
			if (tgt && tgt.matches && tgt.matches('[data-act="flush-toggle"]')) {
				setCookie(COOKIE_FLUSH, tgt.checked ? '1' : '0', 365);
				renderPanel();
				// Если включили — форсим немедленный flush уже накопленных событий
				if (tgt.checked && typeof window.__bsFlush === 'function') window.__bsFlush();
			}
		});

		// Синхронизируем чекбокс с cookie при создании панели
		var cb = panel.querySelector('[data-act="flush-toggle"]');
		if (cb) cb.checked = getCookie(COOKIE_FLUSH) === '1';
	}

	function handlePanelAction(act) {
		if (act === 'collapse') {
			panelState.collapsed = true;
			setCookie(COOKIE_COLLAPSED, '1', 365);
			applyPanelState();
		} else if (act === 'clear') {
			if (confirm('Clear Bloom session stream?')) {
				clearEvents();
				renderPanel();
			}
		} else if (act === 'copy') {
			var json = JSON.stringify(readEvents(), null, 2);
			copyToClipboard(json);
		}
	}

	function applyPanelState() {
		var panel = document.getElementById(PANEL_ID);
		if (!panel) return;
		panel.classList.toggle('bs-collapsed', !!panelState.collapsed);
	}

	function copyToClipboard(text) {
		if (!text) return;
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(text).catch(function () { fallbackCopy(text); });
		} else {
			fallbackCopy(text);
		}
	}

	function fallbackCopy(text) {
		try {
			var ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.left = '-9999px';
			document.body.appendChild(ta);
			ta.select();
			document.execCommand('copy');
			document.body.removeChild(ta);
		} catch (e) {}
	}

	function renderPanel() {
		var panel = document.getElementById(PANEL_ID);
		if (!panel) return;

		var events = readEvents();
		var raw = localStorage.getItem(LS_EVENTS) || '';

		var cartEl = panel.querySelector('.bs-cart');
		if (cartEl) {
			var token = window.__bloomCartToken;
			cartEl.textContent = 'cart: ' + shortToken(token) + (token ? ' 📋' : '');
			cartEl.title = token ? ('cart_token: ' + token + ' (click to copy)') : 'no cart yet';
		}

		var countsEl = panel.querySelector('.bs-counts');
		if (countsEl) {
			var badge = '';
			if (window.__bsTestUser) {
				badge = getCookie(COOKIE_FLUSH) === '1' ? '   🧪 TEST (sending)' : '   🧪 TEST (local only)';
			}
			countsEl.textContent = 'events: ' + events.length + '    size: ' + formatSize(bytesSize(raw)) + badge;
		}

		var body = panel.querySelector('.bs-body');
		if (!body) return;

		if (!events.length) {
			body.innerHTML = '<div class="bs-empty">no events yet</div>';
			return;
		}

		var html = [];
		for (var i = events.length - 1; i >= 0; i--) {
			var evt = events[i];
			var color = EVENT_COLORS[evt.type] || '#111827';
			html.push('<div class="bs-event">');
			html.push('<div class="bs-event-head">');
			html.push('<span class="bs-event-time">' + escapeHtml(formatTime(evt.ts)) + '</span>');
			html.push('<span class="bs-event-type" style="color:' + color + '">' + escapeHtml(evt.type || '?') + '</span>');
			html.push('</div>');

			var fieldsHtml = [];
			for (var k in evt) {
				if (!Object.prototype.hasOwnProperty.call(evt, k)) continue;
				if (k === 'ts' || k === 'type') continue;
				var v = evt[k];
				// объекты/массивы сериализуем в JSON, чтобы не было "[object Object]"
				var disp = (v !== null && typeof v === 'object') ? JSON.stringify(v) : v;
				fieldsHtml.push(
					'<div class="bs-event-field">' +
					'<span class="bs-event-field-k">' + escapeHtml(k) + ':</span> ' +
					'<span class="bs-event-field-v">' + escapeHtml(disp) + '</span>' +
					'</div>'
				);
			}
			if (fieldsHtml.length) {
				html.push('<div class="bs-event-fields">' + fieldsHtml.join('') + '</div>');
			}
			html.push('</div>');
		}
		body.innerHTML = html.join('');
	}

	function initPanel() {
		panelState.collapsed = getCookie(COOKIE_COLLAPSED) === '1';
		injectStyles();
		createPanel();
		applyPanelState();
		renderPanel();
	}

	// ---------- Bootstrap ----------
	function boot() {
		initCartSync().then(function () {
			if (window.__bsSuperuser) {
				initPanel();
				renderPanel();
			}
			firePageloadEvent();
		});
		initListeners();
	}

	// Idempotency guard: если bloom-session.js по какой-то причине подключён/исполнен
	// дважды (дубль <script> при выкатке, повторная инъекция) — НЕ навешиваем
	// listener'ы второй раз, иначе делегированный click пишет каждое событие N раз.
	// Это root-cause фикс двойного счёта ask_ai (15-22 мая 2026); dedup в pushEvent —
	// второй рубеж на случай других источников дублей.
	if (!window.__bloomSessionBooted) {
		window.__bloomSessionBooted = true;
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', boot);
		} else {
			boot();
		}
	}

	// Экспорт для отладки в консоли
	window.BloomSession = {
		push:	pushEvent,
		read:	readEvents,
		clear:	function () { clearEvents(); renderPanel(); },
		expand:	function () {
			panelState.collapsed = false;
			setCookie(COOKIE_COLLAPSED, '0', 365);
			applyPanelState();
		}
	};
})();
